class CollectionAll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const buttons = this.querySelectorAll('.collection-all__filter-button');
    const contents = this.querySelectorAll('.collection-all__layout-view');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        buttons.forEach(btn => btn.classList.remove('active-view'));
        contents.forEach(content => content.classList.remove('show-view'));
        button.classList.add('active-view');
        const targetId = button.getAttribute('data-target');
        const targetContent = this.querySelector(`#${targetId}`);
        if (targetContent) {
          targetContent.classList.add('show-view');
        }
      });
    });
  }
}

customElements.define('collection-all', CollectionAll);
